import { render, staticRenderFns } from "./latestPress.vue?vue&type=template&id=380ca12c&scoped=true&"
import script from "./latestPress.vue?vue&type=script&lang=js&"
export * from "./latestPress.vue?vue&type=script&lang=js&"
import style0 from "./latestPress.vue?vue&type=style&index=0&id=380ca12c&lang=scss&scoped=true&"
import style1 from "./latestPress.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ca12c",
  null
  
)

export default component.exports